import { render, staticRenderFns } from "./ListKeyword.vue?vue&type=template&id=8fadcbae&scoped=true"
import script from "./ListKeyword.vue?vue&type=script&lang=js"
export * from "./ListKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fadcbae",
  null
  
)

export default component.exports